import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { ConfirmationDialogWindow } from 'src/editor/shared/ui-lib/modal-window/dialog-window/confirmation-dialog-window'
import { useMutationWithValidation } from 'src/editor/api/hooks/use-api-mutation-with-validation'
import { websitePagesQuery } from 'src/editor/api/queries/website-pages-query'
import { publishWebsitePage } from 'src/editor/api/website-pages-api'

export interface PublishPageModalProps {
  websiteId: number
  websitePageSetId: number
  websitePageId: number
  isOpened: boolean
  onClose: () => void
}

export const PublishPageModal = ({
  websiteId,
  websitePageSetId,
  websitePageId,
  isOpened,
  onClose,
}: PublishPageModalProps) => {
  const { t } = useTypedTranslation()

  const { fetcher, isLoading } = useMutationWithValidation({
    requestFunction: publishWebsitePage,
    successToastMessage: t(
      'website_settings.sidebar.pages_management.publish_page.published_successfully',
    ),
    handleFinally: onClose,
    setQueryDataArgsOnSuccess: websitePagesQuery.setQueryDataArgs(
      [websiteId],
      prevData => ({
        ...prevData,
        pages: prevData.pages.map(websitePageSet =>
          websitePageSet.id === websitePageSetId
            ? {
                ...websitePageSet,
                locales: websitePageSet.locales.map(websitePage =>
                  websitePage.id === websitePageId
                    ? { ...websitePage, active: true }
                    : websitePage,
                ),
              }
            : websitePageSet,
        ),
      }),
    ),
  })

  const handlePublishPage = () => {
    if (websitePageId) {
      fetcher({ websitePageId })
    }
  }

  return (
    <ConfirmationDialogWindow
      isOpened={isOpened}
      onClose={onClose}
      title={t('website_settings.sidebar.pages_management.publish_page.title')}
      description={t(
        'website_settings.sidebar.pages_management.publish_page.description',
      )}
      cancelButtonProps={{
        children: t('global.cancel'),
        onClick: onClose,
      }}
      confirmButtonProps={{
        isLoading,
        onClick: handlePublishPage,
        children: t(
          'website_settings.sidebar.pages_management.publish_page.publish_button',
        ),
      }}
    />
  )
}
